/**
 * Function to get file extension.
 * @param fileName - name of uploaded file.
 * @return Returns file extension if file has it, undefined otherwise.
 */
export function getFileExtension(fileName: string): string | undefined {
  if (!fileName) return undefined;
  const index = fileName.lastIndexOf('.');
  if (index === -1) return undefined;
  return fileName
    .substring(index)
    .toLowerCase()
    .trim();
}
